/* tslint:disable */

declare var Object: any;
export interface FilesInterface {
  "id"?: number;
}

export class Files implements FilesInterface {
  "id": number;
  constructor(data?: FilesInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Files`.
   */
  public static getModelName() {
    return "Files";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Files for dynamic purposes.
  **/
  public static factory(data: FilesInterface): Files{
    return new Files(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Files',
      plural: 'Files',
      path: 'Files',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/theme/services/sdk/models/Files.ts